import {
  IDS_BASE_URL,
  API_GATEWAY_KEY,
  SYNC_LOINC_AND_SNOMED,
} from "./Constants";
import Cookies from "js-cookie";

export const addNewSnomedForIDSS = async (form) => {
  form.operation = "ADD";
  form.conditionList = form?.idssConditionNames? form?.idssConditionNames : [];

  let payload = {
    snomed: [form],
  };

  let response = await fetch(`${IDS_BASE_URL}${SYNC_LOINC_AND_SNOMED}`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(payload),
  });
  let data = await response.json();
  return data;
};

export const updateSnomedForIDSS = async (form) => {
  form.operation = "UPDATE";
  form.conditionList = form?.idssConditionNames? form?.idssConditionNames : [];

  let payload = {
    snomed: [form],
  };

  let response = await fetch(`${IDS_BASE_URL}${SYNC_LOINC_AND_SNOMED}`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(payload),
  });
  let data = await response.json();
  return data;
};

export const removeSnomedForIDSS = async (snomedCode) => {
  let payload = {
    snomed: [{ snomedCode: snomedCode, operation: "DELETE" }],
  };
  let response = await fetch(`${IDS_BASE_URL}${SYNC_LOINC_AND_SNOMED}`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(payload),
  });
  let data = await response.json();
  return data;
};

export const addNewLOINCForIDSS = async (form) => {
  form.operation = "ADD";
  form.conditionList = form?.idssConditionNames;

  let payload = {
    loinc: [form],
  };

  let response = await fetch(`${IDS_BASE_URL}${SYNC_LOINC_AND_SNOMED}`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(payload),
  });
  let data = await response.json();
  return data;
};

export const updateLoincForIDSS = async (form) => {
  form.operation = "UPDATE";
  form.conditionList = form?.idssConditionNames;
  let payload = {
    loinc: [form],
  };

  let response = await fetch(`${IDS_BASE_URL}${SYNC_LOINC_AND_SNOMED}`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(payload),
  });
  let data = await response.json();
  return data;
};

export const removeLoincForIDSS = async (loincCode) => {
  let payload = {
    loinc: [{ loincCode: loincCode, operation: "DELETE" }],
  };
  let response = await fetch(`${IDS_BASE_URL}${SYNC_LOINC_AND_SNOMED}`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(payload),
  });
  let data = await response.json();
  return data;
};
